'use strict';

/**
 * This file will have general utilities
 */

function getURLParameter(name) {
  // The decodeURIComponent() method decodes a Uniform Resource Identifier (URI) component previously created by encodeURIComponent or by a similar routine.
  return decodeURIComponent((new RegExp('[?|&|$]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [, ''])[1].replace('', '%20')) || null;
}

$.fn.serializeFormToObj = function (verbose) {
  verbose = verbose == null ? true : verbose;

  var node = this[0];
  if (node.tagName.toLowerCase() != 'form') {
    return null;
  }

  $(node).find('select option:first-child').prop('disabled', false);
  var paramsArr = $(node).serializeArray();
  $(node).find('select option:first-child').prop('disabled', true);

  var resultObj = new Object();
  for (var i = 0; i < paramsArr.length; i++) {
    resultObj[paramsArr[i].name] = paramsArr[i].value;
  }

  // Unselected Select option
  var selects = $('select', node);
  for (var i = 0; i < selects.length; i++) {
    if (!$(selects[i]).val() && selects[i].name != null && selects[i].name != '') {
      resultObj[selects[i].name] = null;
    }
  }

  // Checkboxes
  var checkboxes = $("input[type='checkbox']", node);
  for (var i = 0; i < checkboxes.length; i++) {
    if (verbose || $(checkboxes[i]).parents("[data-mogo-ui='BooleanGroup']").length == 0) {
      if (!checkboxes[i].checked && checkboxes[i].name != null && checkboxes[i].name != '') {
        resultObj[checkboxes[i].name] = false;
      } else {
        resultObj[checkboxes[i].name] = true;
      }
    } else if (!verbose && $(checkboxes[i]).parents("[data-mogo-ui='BooleanGroup']").length > 0) {
      delete resultObj[checkboxes[i].name];
    }
  }

  // Unchecked radios
  var radios = $("input[type='radio']", node);
  for (var i = 0; i < radios.length; i++) {
    if (verbose || $(radios[i]).parents("[data-mogo-ui='BooleanGroup']").length == 0) {
      if (radios[i].name != null && radios[i].name != '' && resultObj[radios[i].name] === undefined) {
        resultObj[radios[i].name] = null;
      }
    } else if (!verbose && $(radios[i]).parents("[data-mogo-ui='BooleanGroup']").length > 0) {
      delete resultObj[radios[i].name];
    }
  }

  // Boolean groups, Collections, and AggregateCollections
  var booleanGroups = $("[data-mogo-ui='BooleanGroup'],[data-mogo-ui='Collection'],[data-mogo-ui='AggregateCollection']", node).filter('[name]');
  for (var i = 0; i < booleanGroups.length; i++) {
    resultObj[$(booleanGroups[i]).attr('name')] = $(booleanGroups[i]).mogo().val();
  }

  return resultObj;
};

/* polyfill for IE's origin bug */

if (!window.location.origin) {
  window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
}